import React from 'react';

// A metric's public track record, in a glance. The twin grades its own weekly
// predictions and shows the score honestly — including "no record yet", which
// is the truth for the first couple of weeks and is not something to hide.
const AccuracyBadge = ({ accuracy }) => {
  const n = accuracy?.n_graded || 0;
  if (n === 0) {
    return (
      <span className="text-sm px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300">
        no track record yet
      </span>
    );
  }
  const rate = accuracy.hit_rate; // 0..1
  const pct = Math.round(rate * 100);
  // Green once the twin is landing most weeks in its own band; amber while it
  // is still calibrating. This grades the twin, not the user.
  const tone =
    rate >= 0.6
      ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300'
      : 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300';
  const hits = Math.round(rate * n);
  return (
    <span
      className={`text-sm px-2 py-0.5 rounded-full ${tone}`}
      title={`${hits} of ${n} graded week${n === 1 ? '' : 's'} landed inside the predicted band`}
    >
      {pct}% in band · {n}w
    </span>
  );
};

export default AccuracyBadge;
